/* unplugin-vue-components disabled */import { render } from "./DialogAssetsLib.vue?vue&type=template&id=78e26caf&scoped=true"
import script from "./DialogAssetsLib.vue?vue&type=script&lang=js"
export * from "./DialogAssetsLib.vue?vue&type=script&lang=js"

import "./DialogAssetsLib.vue?vue&type=style&index=0&id=78e26caf&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e26caf"]])

export default __exports__